import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  static values = {
    updateAppCategoryUrl: String,
    appId: Number,
    categories: [String],
    confirmCategories: Object,
  };

  connect() {
    this.#populateCategories();
  }

  submitIfHasCategory(event) {
    const inputValue = event.target.value;

    if (this.categoriesValue.includes(inputValue) && this.#confirmed(inputValue)) {
      this.#submitCategory(inputValue);
    }
  }

  #confirmed(category) {
    const message = this.confirmCategoriesValue[category];

    return !message || window.confirm(message);
  }

  #populateCategories() {
    this.categoriesValue = document
      .getElementById('categories-datalist')
      .querySelectorAll('option')
      .forEach((category) => {
        this.categoriesValue.push(category.value);
      });
  }

  async #submitCategory(category) {
    const csrfToken = document.getElementsByName('csrf-token')[0].content;

    this.#focusNextInput();
    this.inputTarget.disabled = true;

    const response = await fetch(this.updateAppCategoryUrlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ desktop_app: { id: this.appIdValue, category_name: category } }),
    });

    await response.json();

    if (response.ok) {
      this.element.remove();
    } else {
      if (this.inputTarget) this.inputTarget.disabled = false;
    }
  }

  #focusNextInput() {
    const inputs = document.querySelectorAll('.desktop-app-category-input');
    const activeElement = document.activeElement;
    const currentIndex = Array.from(inputs).findIndex((input) => input === activeElement);
    const nextIndex = (currentIndex + 1) % inputs.length;

    inputs[nextIndex].focus();
  }
}
